import React, { useState } from 'react';
import Select from 'react-select';
import Offcanvas from 'react-bootstrap/Offcanvas';

const GoodsDetailsTab = () => {
const [showAdd, setShowAdd] = useState(false);
const [showEdit, setShowEdit] = useState(false);

const handleShowAdd = (e) => {
e.preventDefault();
setShowAdd(true);
};

const handleShowEdit = (e) => {
e.preventDefault();
setShowEdit(true);
};

const handleCloseAdd = () => setShowAdd(false);
const handleCloseEdit = () => setShowEdit(false);

return (
<>
    <form>
        <div className="row border-bottom-2 pb-3">
        
            <div className="col-md-12">
                <div className="py-2">
                    <div className="table-responsive">
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                <th>Shipment No.</th>
                                    <th>Description</th>
                                    <th>Packages</th>
                                    <th>Gross Wt</th>
                                    <th>Volume</th>
                                    <th>Charge Wt</th>
                                    <th>Package Dims</th>
                                    
                                </tr>
                            </thead>
                            <tbody>

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

        </div>
        <div className="py-2">
            <div className="d-flex flex-wrap gap-2 mt-2 pb-2" style={{ borderBottom: '1px solid #d4d4d4' }}>
                {/* <button className="btn btn-primary text-xs" type="button" onClick={handleShowAdd}>
                    New
                </button> */}
                <button className="btn btn-primary text-xs" type="button" >
                    Edit
                </button>
                <button className="btn btn-primary text-xs" type="button">
                    Update
                </button>
            </div>
        </div>
        <div className="row justify-content-end mt-3 gap-2">
            <button className="btn btn-primary text-xs w-fit" type="submit">
                Save
            </button>
            <button className="btn btn-primary text-xs w-fit" type="submit">
                Save & Close
            </button>
            <button className="btn btn-primary text-xs w-fit" type="submit">
                Save & New
            </button>
            <button className="btn btn-primary text-xs w-fit" type="button">
                Close
            </button>
        </div>
    </form>

    <Offcanvas show={showAdd} onHide={handleCloseAdd} placement="end">
        <Offcanvas.Header closeButton>
            <Offcanvas.Title>Origin Pickup Details</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
            <div className="row">
                <div className="col-md-6">
                    <label className="form-label">Pickup Type</label>
                    <Select className="custom-selector w-100" name="" placeholder="Self" />
                </div>
                <div className="col-md-6">
                    <label className="form-label">Date</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="date" className="form-control form-control-sm custom-selector w-100" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Empty Container Pickup</label>
                    <div className="d-flex gap-2 flex-row">
                        <Select className="custom-selector w-100" name="" />
                    </div>
                    <textarea className="form-control  mt-1" rows="3"></textarea>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Bll To</label>
                    <div className="d-flex gap-2 flex-row">
                        <Select className="custom-selector w-100" name="" />
                    </div>
                    <textarea className="form-control  mt-1" rows="3"></textarea>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Pickup Form</label>
                    <Select className="custom-selector w-100" name="" placeholder="Pickup Address" />
                </div>
                <div className="col-md-6">
                    <label className="form-label">Deliver To</label>
                    <Select className="custom-selector w-100" name="" placeholder="Pickup Address" />
                </div>
                <div className="col-md-6">
                    <label className="form-label">Pickup Address</label>

                    <textarea className="form-control" rows="4"></textarea>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Delivery Address</label>

                    <textarea className="form-control" rows="4"></textarea>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Pickup Est Date & Time</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="datetime-local" className="form-control form-control-sm custom-selector w-100" />
                    </div>
                </div>

                <div className="col-md-6">
                    <label className="form-label">Deliver Est Date & Time</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="datetime-local" className="form-control form-control-sm custom-selector w-100" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Pickup Transporter</label>
                    <div className="d-flex gap-2 flex-row">
                        <Select className="custom-selector w-100" name="" />
                    </div>
                    <textarea className="form-control  mt-1" rows="3"></textarea>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Remark</label>

                    <textarea className="form-control  mt-1" rows="4"></textarea>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Transporter Ref No.</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="Text" className="form-control form-control-sm custom-selector w-100" />
                    </div>
                </div>
                <div className="col-md-6" style={{ visibility: "hidden" }}>
                    <label className="form-label">Transporter Ref No.</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="Text" className="form-control form-control-sm custom-selector w-100" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Vehicle No.</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="Text" className="form-control form-control-sm custom-selector w-100" />
                    </div>
                </div>
                <div className="col-md-6" style={{ visibility: "hidden" }}>
                    <label className="form-label">Transporter Ref No.</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="Text" className="form-control form-control-sm custom-selector w-100" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Driver Name</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="Text" className="form-control form-control-sm custom-selector w-100" />
                    </div>
                </div>
                <div className="col-md-6" style={{ visibility: "hidden" }}>
                    <label className="form-label">Transporter Ref No.</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="Text" className="form-control form-control-sm custom-selector w-100" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Charge Type</label>
                    <div className="d-flex gap-2 flex-row">
                        <Select className="custom-selector w-100" name="" placeholder="Prepaid" />
                    </div>
                </div>
                <div className="col-md-6" style={{ visibility: "hidden" }}>
                    <label className="form-label">Transporter Ref No.</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="Text" className="form-control form-control-sm custom-selector w-100" />
                    </div>
                </div>

            </div>

            <div className="d-flex justify-content-end gap-2 mt-5">
                <button className="btn btn-primary text-xs" type="submit">
                    Submit
                </button>
                <button className="btn btn-primary text-xs" type="submit">
                    Save & Close
                </button>
                <button className="btn btn-primary text-xs" type="submit">
                    Save & New
                </button>
                <button className="btn btn-light text-xs" type="button" onClick={handleCloseAdd}>
                    Close
                </button>
            </div>
        </Offcanvas.Body>
    </Offcanvas>

    <Offcanvas show={showEdit} onHide={handleCloseEdit} placement="end">
        <Offcanvas.Header closeButton>
            <Offcanvas.Title>Origin Pickup Details</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
        <div className="row">
                <div className="col-md-6">
                    <label className="form-label">Pickup Type</label>
                    <Select className="custom-selector w-100" name="" placeholder="Self" />
                </div>
                <div className="col-md-6">
                    <label className="form-label">Date</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="date" className="form-control form-control-sm custom-selector w-100" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Empty Container Pickup</label>
                    <div className="d-flex gap-2 flex-row">
                        <Select className="custom-selector w-100" name="" />
                    </div>
                    <textarea className="form-control  mt-1" rows="3"></textarea>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Bll To</label>
                    <div className="d-flex gap-2 flex-row">
                        <Select className="custom-selector w-100" name="" />
                    </div>
                    <textarea className="form-control  mt-1" rows="3"></textarea>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Pickup Form</label>
                    <Select className="custom-selector w-100" name="" placeholder="Pickup Address" />
                </div>
                <div className="col-md-6">
                    <label className="form-label">Deliver To</label>
                    <Select className="custom-selector w-100" name="" placeholder="Pickup Address" />
                </div>
                <div className="col-md-6">
                    <label className="form-label">Pickup Address</label>

                    <textarea className="form-control" rows="4"></textarea>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Delivery Address</label>

                    <textarea className="form-control" rows="4"></textarea>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Pickup Est Date & Time</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="datetime-local" className="form-control form-control-sm custom-selector w-100" />
                    </div>
                </div>

                <div className="col-md-6">
                    <label className="form-label">Deliver Est Date & Time</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="datetime-local" className="form-control form-control-sm custom-selector w-100" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Pickup Transporter</label>
                    <div className="d-flex gap-2 flex-row">
                        <Select className="custom-selector w-100" name="" />
                    </div>
                    <textarea className="form-control  mt-1" rows="3"></textarea>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Remark</label>
                    
                    <textarea className="form-control  mt-1" rows="4"></textarea>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Transporter Ref No.</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="Text" className="form-control form-control-sm custom-selector w-100" />
                    </div>
                </div>
                <div className="col-md-6" style={{ visibility: "hidden" }}>
                    <label className="form-label">Transporter Ref No.</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="Text" className="form-control form-control-sm custom-selector w-100" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Vehicle No.</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="Text" className="form-control form-control-sm custom-selector w-100" />
                    </div>
                </div>
                <div className="col-md-6" style={{ visibility: "hidden" }}>
                    <label className="form-label">Transporter Ref No.</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="Text" className="form-control form-control-sm custom-selector w-100" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Driver Name</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="Text" className="form-control form-control-sm custom-selector w-100" />
                    </div>
                </div>
                <div className="col-md-6" style={{ visibility: "hidden" }}>
                    <label className="form-label">Transporter Ref No.</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="Text" className="form-control form-control-sm custom-selector w-100" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Charge Type</label>
                    <div className="d-flex gap-2 flex-row">
                    <Select className="custom-selector w-100" name="" placeholder="Prepaid" />
                    </div>
                </div>
                <div className="col-md-6" style={{ visibility: "hidden" }}>
                    <label className="form-label">Transporter Ref No.</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="Text" className="form-control form-control-sm custom-selector w-100" />
                    </div>
                </div>

            </div>
            <div className="d-flex justify-content-end gap-2 mt-5">
                <button className="btn btn-primary text-xs" type="submit">
                    Update
                </button>
                <button className="btn btn-primary text-xs" type="submit">
                    Update & Close
                </button>
                <button className="btn btn-primary text-xs" type="submit">
                    Update & New
                </button>
                <button className="btn btn-light text-xs" type="button" onClick={handleCloseEdit}>
                    Close
                </button>
            </div>
        </Offcanvas.Body>
    </Offcanvas>
</>
);
};

export default GoodsDetailsTab;